var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpander(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 12"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6L.6 0 0 .6 4.9 6 .1 11.4l.5.6z"
  })));
}

export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' x='0' y='0' viewBox='0 0 6 12' xml:space='preserve'%3e%3cstyle type='text/css'%3e %3c/style%3e%3cpolygon fill-rule='evenodd' clip-rule='evenodd' points='6 6 0.6 0 0 0.6 4.9 6 0.1 11.4 0.6 12'%3e%3c/polygon%3e%3c/svg%3e";
export { SvgExpander as ReactComponent };